import * as stylex from '@stylexjs/stylex';
import { headerTheme } from '@/styles/headerTheme.stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

/** Shared application header chrome. */
export const headerStyles = stylex.create({
  wrapper: { position: 'relative' },
  header: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '2.6875rem',
    maxHeight: '2.6875rem',
    height: '2.6875rem',
    backgroundColor: headerTheme.background,
    color: colors.white,
  },
  printHidden: { display: { 'default': 'flex', '@media print': 'none' } },
  navbarAction: { cursor: 'pointer', color: { 'default': 'inherit', ':hover': colors.icon } },
  whiteNavbarAction: { cursor: 'pointer', color: { 'default': colors.white, ':hover': colors.icon } },
  themedNavbarAction: { cursor: 'pointer', color: { 'default': colors.accentSubtle, ':hover': colors.icon } },
  menuItem: {
    color: { 'default': colors.text, ':hover': colors.text, ':focus': colors.text },
    fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  externalMlIcon: { transform: 'translateX(-4px)' },
  trainingBadge: { marginLeft: 7 },
  trainingSteps: { fontSize: 'smaller', marginBottom: '0.3125rem' },
  trainingLink: {
    color: { 'default': colors.link, ':hover': colors.link },
    cursor: 'pointer',
    textDecoration: 'underline',
    pointerEvents: 'auto',
    paddingRight: '0.5rem',
  },
  standaloneHeader: { justifyContent: 'space-between' },
  brandedHeader: {
    backgroundColor: colors.headerBrandBackground,
    borderBottomWidth: 5,
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
  },
  brand: { display: 'flex', flexDirection: 'row', marginTop: 'auto' },
  productName: { display: 'flex', flexDirection: 'row', alignItems: 'center', textTransform: 'uppercase' },
  productBaseline: { display: 'flex', alignItems: 'baseline' },
  productInitial: { fontSize: '1.4375rem', lineHeight: 1 },
  productRemainder: { fontSize: '1.25rem', lineHeight: 1 },
  logo: { display: 'flex', alignItems: 'center', width: 80 },
  logoLink: { paddingInline: 0, cursor: 'pointer' },
  disabledLogoLink: { cursor: 'default' },
  logoImage: { marginTop: '0.25rem', marginRight: '0.9375rem', marginBottom: '0.3125rem', marginLeft: '0.3125rem' },
  titleSpacer: { flex: '1 1 auto' },
  treeTitle: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    maxWidth: '28rem',
    minWidth: 0,
    transform: 'translate(-50%, -50%)',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  titleColumn: {
    containerType: 'inline-size',
    display: 'flex',
    minWidth: 0,
    flex: '1 1 auto',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  titleRow: { display: 'flex', width: '100%', minWidth: 0, alignItems: 'center', justifyContent: 'center' },
  titleContent: { minWidth: 0 },
  fullName: {
    display: 'flex',
    maxHeight: 23,
    maxWidth: '100%',
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  name: { fontSize: '1.0625rem', minWidth: 20, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  nameWithBreadcrumbs: { fontSize: '0.875rem', lineHeight: '1.25rem' },
  nameInput: { minWidth: 0, maxWidth: '100%' },
  nameSeparator: {
    marginBlock: 0,
    flexShrink: 0,
    paddingInline: '0.1875rem',
    paddingBottom: '0.125rem',
    fontSize: '1.0625rem',
  },
  navigationIcon: { fontSize: '1.5em' },
  unavailableWorkstep: { color: colors.textMuted },
  mirroredWorkstep: { transform: 'scaleX(-1)' },
  refreshIcon: { marginRight: 2, cursor: 'pointer' },
  lockStatus: { marginRight: '0.75rem', display: 'flex', flex: 'none', flexDirection: 'row' },
  lockLabel: { display: 'flex', flexDirection: 'row' },
  badgePadding: { padding: '0.1875rem' },
  lockIcon: { marginLeft: 2, marginTop: 5 },
  worksheetActions: { display: 'flex', flex: 'none', flexDirection: 'row' },
  impactReportAction: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    marginLeft: '0.3125rem',
    flex: 'none',
    alignItems: 'center',
    paddingRight: '0.3125rem',
  },
  settingsAction: {
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    marginRight: '0.5625rem',
    flex: 'none',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  shareAction: {
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    marginRight: '0.5625rem',
    marginLeft: '0.3125rem',
    flex: 'none',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionTrigger: { cursor: 'pointer' },
  actionIcon: { cursor: 'pointer', textDecoration: 'none' },
  shareTrigger: { display: 'flex', cursor: 'pointer', alignItems: 'center', whiteSpace: 'nowrap' },
  shareIcon: {
    marginRight: { 'default': 7, '@media (max-width: 1024px)': 0 },
    cursor: 'pointer',
    textDecoration: 'none',
  },
  shareLabel: { display: { 'default': null, '@media (max-width: 1024px)': 'none' } },
  userMenu: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    marginLeft: '0.3125rem',
    flex: 'none',
    alignItems: 'center',
    paddingRight: '0.75rem',
  },
  centeredActions: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  userIcon: { flex: '0 0 auto', marginRight: 5 },
  hamburger: { display: 'flex', flexDirection: 'row', marginTop: '0.9375rem', marginBottom: '0.625rem', flex: 'none' },
  hamburgerIcon: { flex: '0 0 auto', paddingRight: 12 },
  accentBar: (color: string) => ({ backgroundColor: color, height: 5, top: 38, position: 'absolute', width: '100%' }),
  workbookMenu: {
    marginLeft: '0.5625rem',
    display: 'flex',
    height: 23,
    flex: 'none',
    alignItems: 'center',
    alignSelf: 'flex-end',
  },
  workbookControls: { display: 'flex', flex: 'none', minWidth: 0, maxWidth: '100%', alignItems: 'center' },
  approvalStatus: {
    marginLeft: '0.5625rem',
    display: 'flex',
    flex: '0 1 auto',
    minWidth: 0,
    alignItems: 'center',
  },
  workbookMenuFocus: {
    display: 'inline-flex',
    borderRadius: '0.25rem',
    boxShadow: { 'default': null, ':focus-within': `0 0 0 2px ${colors.toolThemeLink}` },
  },
  accessibleName: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
  },
  breadcrumbWrapper: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0,
    flex: '0 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  breadcrumbText: { fontSize: 11, marginTop: 0, marginBottom: '0.125rem' },
  breadcrumbList: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    marginBlock: 0,
    flex: '0 1 auto',
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  breadcrumbItem: {
    'maxWidth': '7.8125rem',
    'overflow': 'hidden',
    'textOverflow': 'ellipsis',
    'marginLeft': 2,
    'color': colors.white,
    'cursor': 'pointer',
    '::before': { content: { 'default': '"»"', ':first-child': '""' }, marginRight: 2 },
  },
  breadcrumbLink: { color: colors.white },
  layoutAction: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    marginLeft: '0.3125rem',
    flex: 'none',
    alignItems: 'center',
  },
  lockedTopicActions: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.75rem',
  },
  viewModeActions: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '0.625rem',
    flex: 'none',
    justifyContent: 'flex-end',
    alignSelf: 'stretch',
  },
  viewModeBadge: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.headerViewOnlyText,
    backgroundColor: { 'default': null, ':hover': colors.workbookPrimary },
  },
  copyIcon: { paddingInline: '0.125rem', cursor: 'pointer' },
  copyPending: { cursor: 'not-allowed' },
  exportAction: { cursor: 'pointer', textDecoration: 'none', padding: '0.1875rem' },
  exportIcon: { marginRight: 7, marginTop: 3 },
  viewWorksteps: { alignSelf: 'stretch' },
  worksteps: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '0.0625rem',
    marginLeft: '0.625rem',
    flex: 'none',
    justifyContent: 'flex-end',
  },
  historyActions: { userSelect: 'none' },
  workstepAction: {
    userSelect: 'none',
    cursor: 'pointer',
    transition: 'color 0.2s ease-in',
    color: { 'default': colors.accentSubtle, ':hover': colors.icon, ':active': colors.icon },
  },
  historyError: {
    paddingRight: 10,
    color: { 'default': colors.borderInvalid, ':hover': colors.icon, ':active': colors.icon },
  },
  previousWorkstep: { paddingRight: '0.125rem' },
  previousHistoryMenu: { marginRight: 4 },
  nextHistoryMenu: { display: 'inline-block' },
  historyMenu: { overflowY: 'auto', maxHeight: 400 },
  historyCaret: {
    borderStartStartRadius: 0,
    borderEndStartRadius: 0,
    paddingRight: '0.625rem',
    verticalAlign: 'text-bottom',
  },
  lastWorkstep: { paddingRight: '0.1875rem', paddingLeft: '0.5625rem' },
});
